module.exports = __webpack_public_path__ + "img/snowy-light.fe85c820.png";